/**
 * Calculates grace period based on business rules:
 * - Item Price < 10,000 pesos → Grace period = 3 months
 * - Item Price ≥ 10,000 pesos AND loan terms < 12 months → Grace period = 3 months
 * - Item Price ≥ 10,000 pesos AND loan terms ≥ 12 months → Grace period = 6 months
 *
 * @param itemPrice - The total price of the item in pesos
 * @param loanTermInMonths - The loan term in months
 * @returns The grace period in months
 */
export function calculateGracePeriod(
  itemPrice: number,
  loanTermInMonths: number
): number {
  if (itemPrice < 10000) {
    return 3;
  }

  if (loanTermInMonths < 12) {
    return 3;
  }

  return 6;
}

/**
 * Returns the maximum grace period in months across all available loan terms.
 * Used when multiple Zero Plan options exist (e.g. 3 and 6 months) to show the biggest value in the banner.
 *
 * @param itemPrice - The total price of the item in pesos
 * @param termsInMonths - Available loan terms in months
 * @returns The maximum grace period in months, or 0 if no terms
 */
export function getMaxGracePeriodInMonths(
  itemPrice: number,
  termsInMonths: number[]
): number {
  if (termsInMonths.length === 0) return 0;
  const periods = termsInMonths.map((term) =>
    calculateGracePeriod(itemPrice, term)
  );
  return Math.max(...periods);
}
